import { useSnackbar } from "../../../utils/notificacoes"
import React, { useCallback, useEffect, useReducer, useState } from "react"
import { obterModeloGPT, salvarModeloGPT } from "../../../services/modeloIzzaGPT"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { ModeloIzzaGPTInicial } from "../models/modeloIzzaGPTModel"
import { ModeloIzzaGPTActionsTypes } from "./modeloIzzaGPTActions"
import { ModeloIzzaGPTContext } from "./ModeloIzzaGPTContext"
import { modeloIzzaGPTReducer } from "./modeloIzzaGPTReducer"

export function ModeloIzzaGPTContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(modeloIzzaGPTReducer, ModeloIzzaGPTInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)
    const { enqueueSnackbar } = useSnackbar()

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterModeloGPT(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar")
            } else {
                setErroCarregamento(null)
                dispatch({ type: ModeloIzzaGPTActionsTypes.CARREGAR, payload: response.modelo })
            }
        } catch {
            setErroCarregamento("Erro ao carregar")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
    }, [])

    const salvar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await salvarModeloGPT(autorizacao, dados.modelo)
            if ("retornoErro" in response) {
                enqueueSnackbar(response.mensagem || "Erro ao salvar", { variant: "error" })
            } else {
                enqueueSnackbar("Salvo com sucesso!", { variant: "success" })
            }
        } catch {
            enqueueSnackbar("Erro ao salvar", { variant: "error" })
        } finally {
            setLoading(false)
        }
    }, [dados.modelo])

    return (
        <ModeloIzzaGPTContext.Provider value={{ dados, dispatch, erroCarregamento, salvar }}>
            <Loading />
            {children}
        </ModeloIzzaGPTContext.Provider>
    )
}
